import { Listbox } from '@headlessui/react'
import { CheckIcon } from 'lucide-react'
import { cx } from './classNames'
import type { SelectOption } from './types'
import { renderSelectOptionLabel } from '../selectOptionLabel'

/**
 * Props for a single selectable listbox option row.
 */
export type SelectOptionRowProps = {
  option: SelectOption
  emphasizePrimaryLabel: boolean
}

/**
 * Shared option row renderer for plain and searchable listboxes.
 */
export const SelectOptionRow = ({ option, emphasizePrimaryLabel }: SelectOptionRowProps) => (
  <Listbox.Option
    as="div"
    key={option.value}
    value={option.value}
    disabled={option.disabled}
    className={({ active, disabled: optionDisabled }) =>
      cx(
        'relative cursor-pointer select-none rounded-lg px-3 py-2 pr-8 transition',
        active && !optionDisabled
          ? 'bg-[color-mix(in_srgb,var(--color-focus-ring,#3b82f6)_14%,transparent)] text-(--color-text-primary,#0f172a)'
          : 'text-(--color-text-secondary,#334155)',
        optionDisabled && 'cursor-not-allowed opacity-50',
      )
    }
  >
    {({ selected }) => (
      <>
        {renderSelectOptionLabel(option, selected, emphasizePrimaryLabel)}
        {selected ? (
          <span className="absolute inset-y-0 right-2 flex items-center text-(--color-focus-ring,#2563eb)">
            <CheckIcon className="h-4 w-4" />
          </span>
        ) : null}
      </>
    )}
  </Listbox.Option>
)
